import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../src/environments/environment';
import { Router } from '@angular/router';
import { ConfigurationService } from './configuration.service';

@Injectable({
    providedIn: 'root'
})
export class AppInitService {

    checkUserLoggedInInterval: any;

    constructor(
        private http: HttpClient,
        private router: Router,
        private configurationService: ConfigurationService,
    ) {}

    private createWebDeviceUUID(): string {
        const crypto = self.crypto;

        if (crypto?.randomUUID) {
            return crypto.randomUUID();
        }

        if (crypto?.getRandomValues) {
            return '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, (c) =>
                (Number(c) ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> Number(c) / 4).toString(16)
            );
        }

        return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    }

    getWebDeviceUUID() {
        let webDeviceUUID = localStorage.getItem("webDeviceUUID");
        if (webDeviceUUID) {
            return `${webDeviceUUID}`;
        } else {
            const newUUID = this.createWebDeviceUUID();
            localStorage.setItem("webDeviceUUID", newUUID);
            return newUUID;
        }
    }

    init(): Promise<any> {
        return new Promise<void>((resolve, reject) => {
            
            environment.webDeviceUUID = this.getWebDeviceUUID();
            
            this.configurationService.get().then((response) => {
                environment.configuration = response.configuration;

                if (!environment.configuration.enabledEmbedded) {
                    this.router.navigate(['/maintenance']);
                }

                resolve();
                
            }).catch((err) => {
                console.log("error on init application!", err);
                environment.configuration = {
                    enabledEmbedded: false
                }
                this.router.navigate(['/maintenance']);
                resolve();
            })
        });
    }
}
